var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "choice-layout",
    {
      attrs: {
        "options-number": _vm.options.length,
        "option-search-query": _vm.optionSearchQuery,
        "is-showing-all-options": _vm.isShowingAllOptions,
        "is-showing-load-more-button": _vm.isShowingLoadMoreButton,
      },
      on: { "load-more-options": _vm.onLoadMoreOptions },
    },
    _vm._l(_vm.visibleOptions, function (option, index) {
      return _c("inline-option", {
        key: index,
        attrs: {
          option: option,
          "is-selected": _vm.isSelected(option),
          variant: _vm.inlineOptionVariant,
        },
        on: { select: _vm.onSelect },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }